import wxSdk from 'jweixin-1.4.0'
import wechatService from 'wechat.service'
export default {
    componentName: 'basics',
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
        //微信才开启签名
        this._srartWxSDKEnable()
    },
    methods: {
        onCloseConfirm() {
            this.showConfirm = false;
        },
        _srartWxSDKEnable() {
            //微信签名
            const entryUrl = window.entryUrl;//encodeURIComponent(window.entryUrl)
            setTimeout(async () => {
                    const res = await wechatService.getWechatConfig({
                        url: entryUrl,
                        orgId: http.headers.common['organizationId'],
                    });
                    this._setWxConfig(res.data)
            })


        },
        _setWxConfig(configData) {
            wxSdk.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: configData.appId, // 必填，公众号的唯一标识
                timestamp: configData.timestamp, // 必填，生成签名的时间戳
                nonceStr: configData.nonceStr, // 必填，生成签名的随机串
                signature: configData.signature,// 必填，签名
                jsApiList: ['chooseImage', 'previewImage'],// 必填，需要使用的JS接口列表
                openTagList: ['wx-open-launch-weapp']// 可选，需要使用的开放标签列表

            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/basics.js